<template>
  <div class="container-custom">
    <!-- breadscrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">About us</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯 About Us</h2>
      <v-spacer></v-spacer>
      <button class="btn" @click="editHandler">
        <v-icon class="mr-2">edit</v-icon>
        <span>編輯</span>
      </button>
    </div>

    <!-- block 1 -->
    <div class="block">
      <PageMenu :sections="sections">
        <component :is="sectionView" style="min-height: 800px;" :about="about"></component>
      </PageMenu>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageMenu from '@/components/PageMenu.vue';
import BrandMessaging from '@/views/A_AboutUs/c/A-1-1_AboutUs_BrandMessaging.vue';
import CorporateInvestmentMessage from '@/views/A_AboutUs/c/A-1-2_AboutUs_CorporateInvestmentMessaging.vue';
import PartnerEndorsement from '@/views/A_AboutUs/c/A-1-3_AboutUs_PartnerEndorsement.vue';
import InvestorInformation from '@/views/A_AboutUs/c/A-1-4_AboutUs_InvestorInformation.vue';
import CSR from '@/views/A_AboutUs/c/A-1-5_AboutUs_CSR.vue';
import Employee from '@/views/A_AboutUs/c/A-1-6_AboutUs_EmployeeInvestment&Recruiting.vue';
import VideoRotate from '@/views/A_AboutUs/c/A-1-7_ABoutUs_VideoRotate.vue';
import partnerSay from '@/views/A_AboutUs/c/A-1-8_AboutUs_WhatOurPartnerSay.vue';

export default {
  components: {
    PageMenu,
    BrandMessaging,
    CorporateInvestmentMessage,
    PartnerEndorsement,
    InvestorInformation,
    CSR,
    Employee,
    VideoRotate,
    partnerSay,
  },
  data: () => ({
    sections: [
      { name: 'Brand Messaging', component: 'BrandMessaging' },
      {
        name: 'Corporate Investment Messaging',
        component: 'CorporateInvestmentMessage',
      },
      { name: 'Partner Endorsement', component: 'PartnerEndorsement' },
      { name: 'Investor Information', component: 'InvestorInformation' },
      { name: 'CSR', component: 'CSR' },
      {
        name: 'Employee Investment & Recruiting',
        component: 'Employee',
      },
      { name: 'Video Rotate', component: 'VideoRotate' },
      { name: 'What Our Partners Say', component: 'partnerSay' },
    ],
  }),
  async created() {
    await this.getAbout();
  },
  computed: {
    ...mapState('about', ['about']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },

  methods: {
    ...mapActions('about', {
      getAbout: 'find',
      setAbout: 'setAbout',
    }),
    editHandler() {
      this.$router.push({
        name: 'AboutUsEdit',
        query: {
          section: this.$route.query.section,
        },
      });
    },
  },
};
</script>

<style></style>
